import { captureConsoleIntegration, ErrorEvent, getGlobalScope, init } from '@sentry/react'
import { development, production, releaseName, staging } from 'app/config/constants'

const DSN = 'https://3f9ebfe8a3052be0ca31a2bf6369d24f@o4507930409959424.ingest.de.sentry.io/4508001960198224'
const DSN_DEVELOPMENT = 'https://2710405ae3b1559ddefeca87d7f57e98@o4507930409959424.ingest.de.sentry.io/4508020335050832'
const dsn = development ? DSN_DEVELOPMENT : DSN
const environment = production ? 'production' : staging ? 'staging' : development ? 'development' : 'unknown'

function filterYama(event: ErrorEvent): void {
  event.breadcrumbs = event.breadcrumbs?.filter(record => {
    const url = record.data?.url?.toString()
    return !url?.includes('mc.yandex.com')
  })
}

function isFetchError(event: ErrorEvent): boolean {
  return !!event.exception?.values?.some(e => e.value?.includes('fetch attempts failed'))
}

export function sentry() {
  if (development && process.env.DEVELOPMENT_SENTRY !== 'true') return

  init({
    dsn,
    environment,
    release: releaseName,
    integrations: [
      captureConsoleIntegration({ levels: ['error'] }),
    ],
    attachStacktrace: true,
    async beforeSend(event, hint) {
      const error = hint.originalException as Error
      filterYama(event)
      if (isFetchError(event)) return null
      if (error?.message?.includes('Failed to fetch')) return null
      return event
    },
  })

  if (development) getGlobalScope().setTag('application', 'try-on-client')
}
